<template>
    <div class="floatingNotificationsHolder">

        <div class="infoCard shadowed fs-small mt-2 radius-normal border-medium pointer" @mouseover="mouseOver(notification)" @mouseleave="mouseLeave(notification)" v-for="notification, index in floatingNotifications" v-if="showFloatNotificationCondition(notification, index)">
            <timed-bar class="mb-1" :pause="notification.floatHovering" @done="closeNotification(notification)"></timed-bar>

            <notification class="pt-1" :notification="notification" :options="notificationOptions" @closeNotification="closeNotification(notification)"></notification>
        </div>

    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import Notification from '@/components/common/notifications/default'
import TimedBar from './timedBar'

export default {
    data: function () {
        return {
            maxNotifications: 9,
            notificationOptions: {
                showMarkAsReadDelete: false,
                markAsReadOnClick: true
            }
        }
    },
    computed: {
        ...mapGetters([
            'getFloatingNotifications',
        ]),
        floatingNotifications: function () {
            return this.getFloatingNotifications
        },
    },
    methods: {
        ...mapActions([
            'removeFloatingNotification'
        ]),
        showFloatNotificationCondition: function (notification, index) {
            return index < 9 || notification.markedAsRead == false
        },
        mouseOver: function(notification){
            this.$set(notification, 'floatHovering', true)
        },
        mouseLeave: function(notification) {
            this.$set(notification, 'floatHovering', false)
        },
        closeNotification: function (notification) {
            this.removeFloatingNotification(notification)
        }
    },
    components: {
        Notification,
        TimedBar
    }
}
</script>

<style lang="scss" scoped>
    @import '../../../assets/scss/_variables.scss';

    .floatingNotificationsHolder {
        position: fixed;
        width: 320px;
        top: 50px;
        right: 25px;
        z-index: 10;

        .infoCard {
            background-color: $lightest;
            
            .date {
                font-size: 12px;
                font-style: italic;
                line-height: 1.58;
            }

            .infoContent {
                line-height: 1.36;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// floatingNotifications.vue?49ba95c7